/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import BreadCrum from "../../../components/layout/BreadCrumb";
import styled from "styled-components";
import CustomerDetail from "../../../components/customer/CustomerDetail";
import AccessibleLocker from "../../../components/visitLogs/AccessibleLocker";
import LockerAccessHistory from "../../../components/visitLogs/LockerAccessHistory";
import { Container, KeyValueText, KeyTxt, ValueTxt, CatBtn } from "../../../components/styledComponent/Common";
import { useNavigate, useParams } from "react-router-dom";
import { useCrudForm } from "../../../api/useCrudForm";
import { useEffect, useState } from "react";
import { endpoints } from "../../../api/endpoints";
import { valuesTypes } from "../../customer/form/DetailsForm";
import moment from "moment";
import { ArrowBack } from "@mui/icons-material";

const LayoutNewCustomerReg = styled(Box)`
    padding: 10px 0;
`;

const UserVerification = () => {
    const [customerDetails, setCustomerDetails] = useState<valuesTypes | null>();
    const [lockerAccessHistory, setLockerAccessHistory] = useState<Array<any>>([]);
    const [count, setCount] = useState<any>(0);
    const [skip, setSkip] = useState<any>(0);
    const [take, setTake] = useState<any>(10);
    const [loading, setLoading] = useState<boolean>(false);
    const [checkInTime, setCheckInTime] = useState<string>('');
    const { id, time } = useParams<{ id: string, time: string }>();
    const [customerLoading, setCustomerLoading] = useState(true)

    const { get } = useCrudForm();
    const navigate = useNavigate();

    useEffect(() => {
        if (id) {
            get({
                endpoints: `${endpoints.customer.api}/${id}?isMainTable=true`,
                onSuccess: (data: any) => {
                    const customerInfo = data.data.customerInfo
                    const mapCustomerInfo = Object.keys(customerInfo).reduce((acc: any, key: any) => Object.assign(acc, { [key]: customerInfo[key] !== '' ? customerInfo[key] : null, ['temp' + key]: data.data.tempcustomerInfo !== null ? data.data.tempcustomerInfo[key] !== '' ? data.data.tempcustomerInfo[key] : null : undefined, ['isSame' + key]: true }), {})
                    setCustomerDetails(mapCustomerInfo)
                    setCustomerLoading(false)
                },
                onError: (error: any) => {
                    console.log(error)
                }
            })
        }
    }, [id]);

    useEffect(() => {
        if (id) {
            get({
                endpoints: `${endpoints.lockerAccessHistory.api}?customerId=${id}&skip=${skip * take}&take=${take}`,
                onSuccess: (data: any) => {
                    setLockerAccessHistory(data?.data.list)
                    setCount(data.data.count)
                    setLoading(false)
                },
                onError: (error: any) => {
                    setLoading(false)
                    console.log(error)
                }
            })
        }

    }, [skip, take]);

    useEffect(() => {
        setCheckInTime(time ? moment(parseInt(time)).format('hh:mm A') : '');
    }, [time]);

    return (
        <Box>
            <TopBreadcrumbs />
            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
                <Typography variant="h5" component="h2" mt={3} fontWeight={600}>User Verification</Typography>
                <Button onClick={() => navigate('/visit-logs')} variant="contained" sx={{ padding: '4px 8px', backgroundColor: '#3150A1', marginLeft: '16px', '&:hover': { backgroundColor: '#3150A1', } }}>
                    <ArrowBack />
                    <Typography style={{ fontSize: '14px', marginLeft: '4px' }}>Back</Typography>
                </Button>
            </Stack>


            <LayoutNewCustomerReg>
                <CustomerDetail customer={customerDetails} loading={customerLoading} />
                <Container sx={{ width: "100%", marginTop: "15px" }}>
                    <Grid container>
                        <Typography component="div" mb={2} sx={{ color: "black", fontWeight: "700", fontSize: "20px" }}>
                            Locker Check In/Out
                        </Typography>

                        <Grid container spacing={2}>
                            <Grid item xs={6} md={6}>
                                <KeyValueText mt={2}>
                                    <KeyTxt>Check In:</KeyTxt>
                                    <ValueTxt>
                                        <CatBtn bg="rgba(33, 150, 83, 0.2)" text="green">
                                            {checkInTime}
                                        </CatBtn>
                                    </ValueTxt>
                                </KeyValueText>
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
                <Grid container spacing={2}>
                    <Grid item xs={6} md={6}>
                        <AccessibleLocker customerId={id} customerLocker={customerDetails?.customerLockers} />
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <LockerAccessHistory lockerAccessHistory={lockerAccessHistory} loading={loading} count={count} setSkip={setSkip} setTake={setTake} take={take} skip={skip} />
                    </Grid>
                </Grid>
            </LayoutNewCustomerReg>
        </Box>
    );
}

const TopBreadcrumbs = () => {
    const location = [{ name: "Visit Logs", to: "/visit-logs" }, { name: "Verification" }]
    return (
        <BreadCrum location={location} />
    );
}

export default UserVerification;
